import { createContext, useCallback, useContext, useState } from 'react';
import ToastItem from './toasterItem/ToastItem';

// Context
const ToasterContext = createContext(undefined);

let externalAddToast = null;

export const useToaster = () => {
    const context = useContext(ToasterContext);
    if (!context) {
        throw new Error('useToaster must be used within a ToasterProvider');
    }
    return context;
};

// Provider
export const ToasterProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);

    const addToast = useCallback((toast) => {
        const id = Math.random().toString(36).substr(2, 9);
        const newToast = { ...toast, id };

        setToasts((prev) => [...prev, newToast]);

        const duration = toast.duration || 5000;
        setTimeout(() => {
            removeToast(id);
        }, duration);
    }, []);

    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, []);

    externalAddToast = addToast;

    return (
        <ToasterContext.Provider value={{ addToast, removeToast }}>
            {children}
            <ToastItem toastsArr={toasts} onRemove={removeToast} />
        </ToasterContext.Provider>
    );
};

export const getToasterHandler = () => externalAddToast;